<template>
    <form id="error" class="payment-result-form" :style="'display:' + show">
        <h1>Cancelled</h1>
        <span class="description">Your payment has been cancelled.</span>
        <br /><br />
        <button name="retry" class="btn btn-primary">Retry</button>
        <br /> <br />
        <router-link to="menu" class="btn btn-primary">Continue Shopping</router-link>
    </form>
</template>
<!-- Scripts-->
<script>
export default {
  name: "ErrorForm",
  data() {
    return {
      show: 'none',
    }
  },
  methods: {
      showForm(bool){
          this.show = bool?"block":"none";
      },
  },
  created() {

  },
  mounted() {   
    
  }
};
</script>
<!-- Styles -->
<style scoped>
</style>